import { IInventoryDashboardData } from 'src/apis/dashboard/dashboardInventory.interfaces';

export const dashboardInventoryMock: IInventoryDashboardData = {
  summary: {
    totalItems: 100,
    totalValue: 100000,
    activeCategories: 100,
    lowStockItems: 100,
    outOfStockItems: 100,
  },
  status: {
    available: 100,
    lowStock: 100,
    outOfStock: 100,
    overstocked: 100,
  },
  condition: {
    new: 100,
    good: 100,
    fair: 100,
    poor: 100,
    damaged: 100,
  },
  byCategory: {
    electronics: 100,
    furniture: 100,
    books: 100,
    sports: 100,
    labEquipment: 100,
    officeSupplies: 100,
    uniforms: 100,
    other: 100,
  },
  value: {
    totalValue: 100000,
    byCategory: {
      electronics: 100,
      furniture: 100,
      books: 100,
      sports: 100,
      labEquipment: 100,
      officeSupplies: 100,
      uniforms: 100,
      other: 100,
    },
  },
  period: {
    startDate: '2024-01-01',
    endDate: '2024-12-31',
  },
};
